import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';

import { Button } from '@repo/design-system-kit/components/button/button';
import { LottiePlayer } from '@repo/design-system-kit/components/lottie-player/lottie-player';
import errorLottie from '@repo/visual-assets/dotlottie/lottie_pop_general_error404.lottie';

import styles from './styles.module.css';

export default class RegistrationPricePlanErrorController extends Controller {
  button = Button;
  lottiePlayer = LottiePlayer;
  errorLottie = errorLottie;

  @service router;

  @action
  refreshRoute() {
    this.router.transitionTo('registration.price-plans');
  }
  styles = styles;
}
